import colors from './colorVariants';

export const brandColors = {
  blue: colors.blue,
  green: colors.green,
  red: colors.red,
}


export const breakpoints = ['786px', '1600px']

export default {
  colors: {
    brand: Object.values(brandColors)[0],
    text: colors.black,
    background: colors.white,
    ...colors,
  },
  fonts: {
    head: `'Univers Next', sans-serif`,
    sans: `'basis-grotesque', sans-serif`,
    mono: `'basis-grotesque-mono-bold-pro', monospace`,
  },
  buttons: {
    primary: {
      color: 'white',
      bg: 'text',
    },
    test: {
      color: 'green',
      bg: 'blue',
    }
  },
  space: [0, '1rem', '2rem', '3rem', '4rem', '6rem'],
  fontSizes: ['1.5rem', '1.75rem', '2.25rem', '3rem', '3.5rem', '6rem'],
  radii: [0, 1, 2, 4, 6, 8, 16],
  containerWidth: "1200px",
  minComponentWidth: "300px",
  breakpoints: breakpoints,
  mediaQueries: {
    small: `@media screen and (min-width: ${breakpoints[0]})`,
    large: `@media screen and (min-width: ${breakpoints[1]})`,
  }
  // scale: 12 / 16,
  // fontSize: {
  //   desktop: 12,
  //   tablet: 10,
  //   mobile: 8
  // },
  // breakpoints: {
  //   values: {
  //     xs: 0,
  //     sm: 1024,
  //     md: 1600
  //   }
  // }
}

export const lightTheme = {
  colors: {
    brand: Object.values(brandColors)[0], // this is only a default and gets overriden by module options
    text: colors.black,
    background: colors.grey,
  },
}

export const darkTheme = {
  colors: {
    brand: Object.values(brandColors)[0], // this is only a default and gets overriden by module options
    text: colors.white,
    background: colors.grey,
  },
}

export const brandTheme = {
  colors: {
    brand: colors.green,
    text: colors.white,
  },
}
